<td-wb-split-buttons class="td-wb-currency-selector"
                     [ariaLabel]="ariaLabel()"
                     [ariaLabelledBy]="ariaLabelledBy()"
                     [disabled]="disabledByCva()"
                     [ngModel]="value()"
                     (ngModelChange)="onCurrencyChange($event)">
  @for (code of codes(); track code) {
    <td-wb-split-button class="td-wb-currency-selector__button"
                        [value]="code"
                        [attr.aria-label]="code"
                        [attr.aria-describedby]="ariaDescribedby()"
                        [attr.aria-pressed]="value() === code">
      <td-wb-split-button-data>
        <td-wb-icon-flag aria-hidden="true"
                         [value]="code"
                         [size]="size()" />
        <span class="td-wb-currency-selector__code notranslate"
              translate="no"
              [textContent]="code"></span>
      </td-wb-split-button-data>
    </td-wb-split-button>
  }
</td-wb-split-buttons>
